const axios = require('axios');
const assert = require('assert');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class BookingChannelConnector {

  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  // ======== Privacy Policy ========

  async listBookingChannelPrivacyPolicy({ bookingChannelId }) {
    assert(bookingChannelId, 'bookingChannelId is required');
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/booking-channel/${bookingChannelId}/privacy-policy`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async createBookingChannelPrivacyPolicy({ bookingChannelId, payload, headers }) {
    assert(bookingChannelId, 'bookingChannelId is required');
    assert(payload, 'payload is required');
    try {
      const { data } = await this.httpClient.post(`/${CURRENT_VERSION}/booking-channel/${bookingChannelId}/privacy-policy`, payload, {
        headers,
      });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async deleteBookingChannelPrivacyPolicy({ bookingChannelId, privacyPolicyId }) {
    assert(bookingChannelId, 'bookingChannelId is required');
    assert(privacyPolicyId, 'privacyPolicyId is required');
    try {
      const { data } = await this.httpClient.delete(`/${CURRENT_VERSION}/booking-channel/${bookingChannelId}/privacy-policy/${privacyPolicyId}`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  // ======== Terms and Conditions ========

  async listBookingChannelTermAndCondition({ bookingChannelId }) {
    assert(bookingChannelId, 'bookingChannelId is required');
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/booking-channel/${bookingChannelId}/terms-and-conditions`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async createBookingChannelTermAndCondition({ bookingChannelId, payload, headers }) {
    assert(bookingChannelId, 'bookingChannelId is required');
    assert(payload, 'payload is required');
    try {
      const { data } = await this.httpClient.post(`/${CURRENT_VERSION}/booking-channel/${bookingChannelId}/terms-and-conditions`, payload, {
        headers,
      });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async deleteBookingChannelTermAndCondition({ bookingChannelId, termAndConditionId }) {
    assert(bookingChannelId, 'bookingChannelId is required');
    assert(termAndConditionId, 'termAndConditionId is required');
    try {
      const { data } = await this.httpClient.delete(`/${CURRENT_VERSION}/booking-channel/${bookingChannelId}/terms-and-conditions/${termAndConditionId}`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  // ======== App Release Intents ========
  async getBookingChannelAppPublishKeys({ bookingChannelId }) {
    assert(bookingChannelId, 'bookingChannelId is required');
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/booking-channel/${bookingChannelId}/app-publish-key-settings`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async setBookingChannelAppPublishKeys({ bookingChannelId, payload, headers }) {
    assert(bookingChannelId, 'bookingChannelId is required');
    assert(payload, 'payload is required');
    try {
      const { data } = await this.httpClient.post(`/${CURRENT_VERSION}/booking-channel/${bookingChannelId}/app-publish-key-settings`, payload, {
        headers,
      });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }

}

module.exports = {
  BookingChannelConnector,
};
